import styled from '@emotion/styled'

export const Wrapper = styled.div`
  position: relative;
`

export const IconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;

  .accordion-arrow-icon::part(icon) {
    cursor: pointer;
    z-index: 0;
  }
`
